import { render, staticRenderFns } from "./InventoryEvent.vue?vue&type=template&id=25cd813e&scoped=true"
import script from "./InventoryEvent.vue?vue&type=script&lang=js"
export * from "./InventoryEvent.vue?vue&type=script&lang=js"
import style0 from "./InventoryEvent.vue?vue&type=style&index=0&id=25cd813e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25cd813e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25cd813e')) {
      api.createRecord('25cd813e', component.options)
    } else {
      api.reload('25cd813e', component.options)
    }
    module.hot.accept("./InventoryEvent.vue?vue&type=template&id=25cd813e&scoped=true", function () {
      api.rerender('25cd813e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inventory/InventoryEvent.vue"
export default component.exports